export enum AvailabilityTypes {
  AVAILABLE = 1,
  UNAVAILABLE = 2
}

export const AvailabilityTypeLabels: Record<AvailabilityTypes, string> = {
  [AvailabilityTypes.AVAILABLE]: "Beschikbaar",
  [AvailabilityTypes.UNAVAILABLE]: "Niet beschikbaar"
}
